var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchNiceDcv32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-NICE-DCV_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-NICE-DCV_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-NICE-DCV_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5347906,15.0376432 C24.1637906,16.5176432 20.8587906,18.0216432 17.2297906,19.2726432 C14.7237906,20.1366432 12.1597906,20.8356432 9.85879056,21.2756432 C11.7607906,26.2946432 15.3597906,29.5626432 18.8567906,28.9706432 C22.0727906,28.4276432 24.4617906,24.6016432 24.7997906,19.4506432 L25.7977906,19.5166432 C25.4227906,25.2266432 22.7637906,29.3256432 19.0227906,29.9566432 C18.7017906,30.0116432 18.3797906,30.0376432 18.0587906,30.0376432 C14.3777906,30.0376432 10.7627906,26.5606432 8.86279056,21.4516432 C7.60479056,21.6546432 6.44079056,21.7756432 5.45279056,21.7756432 C3.63279056,21.7756432 2.37679056,21.3956432 2.07079056,20.5096432 C1.70679056,19.4536432 2.74779056,18.1276432 5.16479056,16.5676432 L5.70779056,17.4076432 C3.35179056,18.9286432 2.90779056,19.8676432 3.01579056,20.1836432 C3.23379056,20.8136432 5.27879056,20.9996432 8.53779056,20.4906432 C8.23679056,19.5416432 7.98679056,18.5496432 7.81179056,17.5136432 C7.18979056,13.8306432 7.50179056,10.2106432 8.68779056,7.31964324 C9.90679056,4.34864324 11.9067906,2.48764324 14.3177906,2.07964324 C17.2177906,1.59264324 20.3217906,3.35964324 22.6007906,6.81564324 L21.7667906,7.36664324 C19.7107906,4.25064324 16.9877906,2.64064324 14.4837906,3.06664324 C12.4267906,3.41364324 10.6957906,5.05864324 9.61279056,7.69964324 C8.49679056,10.4196432 8.20779056,13.8466432 8.79879056,17.3466432 C8.97279056,18.3846432 9.22479056,19.3756432 9.52979056,20.3206432 C11.6167906,19.9326432 14.1107906,19.2896432 16.9037906,18.3276432 C20.4637906,17.1006432 23.6957906,15.6306432 26.0057906,14.1896432 C28.6027906,12.5676432 29.1007906,11.5666432 28.9847906,11.2306432 C28.8847906,10.9406432 28.0477906,10.4946432 25.5487906,10.6706432 L25.4777906,9.67364324 C28.0837906,9.48764324 29.5847906,9.90264324 29.9307906,10.9046432 C30.3087906,12.0046432 29.1667906,13.3946432 26.5347906,15.0376432",
    id: "Fill-6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchNiceDcv32);
export default __webpack_public_path__ + "static/media/Arch_NICE-DCV_32.8cb992259ccaf04d29faa7af9c23bfe7.svg";
export { ForwardRef as ReactComponent };